import { withWizardRefetch } from "../withWizardRefetch.js";
import { useProductSelectQuestionControlForm_ModifyWizardSettingsMutation } from "./ProductBox.generated.js";

export const useProductSelectQuestionControlForm_ModifyWizardSettingsMutationWithWizardRefetch =
  withWizardRefetch(
    useProductSelectQuestionControlForm_ModifyWizardSettingsMutation
  );
